import { Component, OnInit } from '@angular/core';
import { BasicList } from '../../../classes';
import { LoopBackAuth, OrderItemApi } from '../../../../assets/js/lb-sdk';
import { BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-discounts',
  templateUrl: './discounts.component.html',
  styleUrls: ['./discounts.component.css']
})
export class DiscountsComponent extends BasicList {
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'referenceNumber', placeholder: 'Order Reference', exact: true },
      { name: 'partnerId', placeholder: 'Agent id', exact: true }
    ],
    filters: {}
  };

  constructor(
    private orderItemApi: OrderItemApi,
    private loopBackAuth: LoopBackAuth,
    private modalService: BsModalService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        totalDiscount: 0,
        partnerId: this.getUser().partnerId || undefined
      },
      include: 'order',
      order: 'id DESC'
    };
    this.settings = {
      createComponent: undefined,
      api: {
        paginate: this.orderItemApi.search.bind(this.orderItemApi),
        deleteById: this.orderItemApi.deleteById.bind(this.orderItemApi)
      },
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }
}
